
    import Vue from "vue";
    import Component from "vue-class-component";
    import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
    import HeadingGroup from "@/features/shared/components/HeadingGroup.vue";
    import { Prop } from "vue-property-decorator";
    import {
        EndorsementMultiLanguagePositionViewModel,
        EndorsementsClient,
        EndorsementDetailsModel
    } from "@/api-client";
    import EndorsementStatusBadge from "@/features/endorsements/components/EndorsementStatusBadge.vue";
    import ButtonWithConfirm from "@/features/shared/components/ButtonWithConfirm.vue";
    import LabelOptional from "@/features/shared/components/LabelOptional.vue";
    import OfficialSignature from "@/features/shared/components/OfficialSignature.vue";
    import QrCode from "@/components/QrCode.vue";
    import { authService } from "@/AuthService";
    import AdditionalInfoButton from "@/features/shared/components/AdditionalInfoButton.vue";
    import PopoverInfo from "@/components/PopoverInfo.vue";
    import DocumentPersonalInfo from "@/features/shared/components/DocumentPersonalInfo.vue";
    import DocumentValidityQueryTimestamp from "@/features/shared/components/DocumentValidityQueryTimestamp.vue";

    @Component({
        components: {
            AdditionalInfoButton,
            OfficialSignature,
            EndorsementStatusBadge,
            SectionPageHeading,
            HeadingGroup,
            ButtonWithConfirm,
            LabelOptional,
            QrCode,
            PopoverInfo,
            DocumentPersonalInfo,
            DocumentValidityQueryTimestamp
        }
    })
    export default class EndorsementDetailsContent extends Vue {
        @Prop({ required: true })
        id!: string;

        @Prop({ required: true })
        details!: EndorsementDetailsModel;

        @Prop()
        isOfficial!: boolean;

        endorsement: EndorsementDetailsModel = this.details;

        dataLoaded = false;
        
        async created() {
            if (authService.isLoggedIn) {
                if (!this.endorsement)
                    this.endorsement = await new EndorsementsClient().details(this.id);
            }
            this.dataLoaded = true;

            this.$watch(
                () => this.details,
                (details) => (this.endorsement = details)
            );
        }

        get linkToCertificate(): string {
            return this.$router.resolve({
                name: "certificate-details",
                params: {
                    seafarerId: this.endorsement.seafarerId,
                    id: this.endorsement.certificateId
                }
            }).href;
        }

        get isPublicQuery() {
            return !this.id;
        }

        fields = [
            {
                key: "positionName",
                label: this.$ls.Endorsements_Details_Table_Label_PositionName,
                thClass: "w-15",
                sortable: false,
                formatter: (
                    value: any,
                    key: any,
                    item: EndorsementMultiLanguagePositionViewModel
                ) => item.positionName.localized,
            },
            {
                key: "restrictions",
                label: this.$ls.Endorsements_Details_Table_Label_Restrictions,
                sortable: false,
                thClass: "w-35",
                formatter: (
                    value: any,
                    key: any,
                    item: EndorsementMultiLanguagePositionViewModel
                ) => item.restrictions.map((r) => r.localized).join("; ") || this.$ls.Applications_Endorsement_Table_Restrictions_None,
            },
            {
                key: "positionLevelName",
                label: this.$ls.Endorsements_Details_Table_Label_PositionLevelName,
                thClass: "w-15",
                sortable: false,
                formatter: (
                    value: any,
                    key: any,
                    item: EndorsementMultiLanguagePositionViewModel
                ) => item.positionLevelName.localized,
            },
            {
                key: "responsibilities",
                label: this.$ls.Endorsements_Details_Table_Label_Responsibilities,
                thClass: "w-35",
                sortable: false,
                formatter: (
                    value: any,
                    key: any,
                    item: EndorsementMultiLanguagePositionViewModel
                ) => item.responsibilities?.localized || "-",
            },
        ];
    }
